import React, { useState, useCallback } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
// All MUI Element
import Box from "@mui/material/Box";
import AddIcon from "@mui/icons-material/Add";
// Others
import { ButtonUI } from "../../Common";
import { regexName } from "../../../util/regularExpress";
import AddLocation from "./AddLocation";

// Dropdown list for connection
const dataProviderList = [
  { value: "S3", text: "AWS S3" },
  { value: "Salesforce", text: "Salesforce" },
  { value: "sftp", text: "SFTP" },
  { value: "azure", text: "Azure Blob" },
  { value: "sharepoint", text: "SharePoint" },
  { value: "mysql", text: "Aurora MySQL" },
  { value: "veevavault", text: "Veeva Vault" },
  { value: "snowflake", text: "Snowflake" },
];

const AddConnection = (props) => {
  const { loadLocationList } = props;
  const { Workspace_id, accessRole } = useSelector((state) => state?.workspace?.workspace);

  const [locationList, setLocationList] = useState("");
  const [openLocationPopup, setOpenLocationPopup] = useState(false);
  const [selectedConnection, setSelectedConnection] = useState({
    stage: 0,
    url: "/",
    type: "",
    name: "",
    hasUploadPermission: false,
  });

  const validateName = useCallback((str, setData) => {
    const isValid = regexName(str, "alphaWithUnderscore");
    if (isValid) setData(str);
  }, []);

  return (
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", width: "100%" }}>
      {[1, 2].includes(accessRole) ? (
        <ButtonUI
          endIcon={<AddIcon />}
          variant="contained"
          color="info"
          style={{ width: "auto" }}
          onClick={() => {
            setSelectedConnection((prev) => ({
              stage: 0,
              url: "/",
              type: "",
              name: prev.name,
            }));
            setOpenLocationPopup(true);
          }}
        >
          Add Connection
        </ButtonUI>
      ) : null}
      {openLocationPopup && (
        <AddLocation
          configData={{
            open: openLocationPopup,
            setOpen: setOpenLocationPopup,
            popupTitle: selectedConnection.stage ? "Edit Connection" : "Add Connection",
            alphaWithUnderscore: validateName,
            locationList,
            setLocationList,
            Workspace_id,
            dataProviderList,
            loadLocationList,
            stage: selectedConnection.stage,
            accessRole,
          }}
        />
      )}
    </Box>
  );
};

AddConnection.propTypes = {
  loadLocationList: PropTypes.func.isRequired,
};

export default AddConnection;
